import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

const employeeFoodieSlice = createSlice({
    name: 'employeeFoodie',
    initialState: {
        getColorAttendance: [],
        getSecurityLogs: [],
        getFirstFoodieSetting: {},
        getFoodieRecordById: [],
        createsFoodieRecord: [],
        addDeviceToListFoodie: {},
        updateFoodieSettingColor: [],
        updateSettingsRestrictions: [],
        updateFoodieRecordById: {},
        getAllFoodieDepartment: {},
        getAllFoodieDevices: [],
        createsFoodieDepartment: {},
        updateFoodieDepartment: {},
        removeDeviceFoodie: false,
        getColorFoodie: null
    },

    reducers: {
        ClearDeleteDeviceToListFoodie: (state, action) => {
            state.removeDeviceFoodie = false;
        },
    },
    extraReducers: {
        'employeeFoodie/getColorAttendance/fulfilled': (state, action) => {
            state.getColorAttendance = ResponseApi(action.payload);
        },
        'employeeFoodie/getColorFoodie/fulfilled': (state, action) => {
            state.getColorFoodie = ResponseApi(action.payload);
        },
        'employeeFoodie/getSecurityLogs/fulfilled': (state, action) => {
            state.getSecurityLogs = ResponseApi(action.payload);
        },
        'employeeFoodie/removeDeviceFoodie/fulfilled': (state, action) => {
            state.removeDeviceFoodie = ResponseApi(action.payload);
        },
        'employeeFoodie/getFirstFoodieSetting/fulfilled': (state, action) => {
            state.getFirstFoodieSetting = ResponseApi(action.payload);
        },
        'employeeFoodie/getAllFoodieDepartment/fulfilled': (state, action) => {
            state.getAllFoodieDepartment = ResponseApi(action.payload);
        },
        'employeeFoodie/updateFoodieDepartment/fulfilled': (state, action) => {
            state.updateFoodieDepartment = ResponseApi(action.payload);
        },
        'employeeFoodie/getAllFoodieDevices/fulfilled': (state, action) => {
            state.getAllFoodieDevices = ResponseApi(action.payload);
        },
        'employeeFoodie/createsFoodieDepartment/fulfilled': (state, action) => {
            state.createsFoodieDepartment = ResponseApi(action.payload);
        },
        'employeeFoodie/getFoodieRecordById/fulfilled': (state, action) => {
            state.getFoodieRecordById = ResponseApi(action.payload);
        },
        'employeeFoodie/createsFoodieRecord/fulfilled': (state, action) => {
            state.createsFoodieRecord = ResponseApi(action.payload);
        },
        'employeeFoodie/addDeviceToListFoodie/fulfilled': (state, action) => {
            state.addDeviceToListFoodie = ResponseApi(action.payload);
        },
        'employeeFoodie/updateFoodieSettingColor/fulfilled': (state, action) => {
            state.updateFoodieSettingColor = ResponseApi(action.payload);
        },
        'employeeFoodie/updateSettingsRestrictions/fulfilled': (state, action) => {
            state.updateSettingsRestrictions = ResponseApi(action.payload);
        },
        'employeeFoodie/updateFoodieRecordById/fulfilled': (state, action) => {
            state.updateFoodieRecordById = ResponseApi(action.payload);
        },
    },
});

export const { ClearDeleteDeviceToListFoodie } = employeeFoodieSlice.actions;

export default employeeFoodieSlice.reducer;
